<template>
    <div class="roothome_m">

        <div class="leftSide_m">

            <!--<a href="#go">-->
            <router-link style="text-align: center;" to="go">
                <img class="im_logoad_m" src="/static/imgs/advicep_horizontal_w.png"/>
            </router-link>
            <!--</a>-->

            <span v-if="passoIndex != 3" class="tx_bemvindo"> {{ getInterText(inter_ind.bemvindo) }} </span>

        </div>






        <div class="rightSide_m">

            <div class="parts" v-if="passoIndex == 0" style="width: 100%;">

                <div class="div_nome">
                    <!--<span class="tx_nome_before_w" @click="clickInput(0, true)" v-if="!editing[0].status" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.nome) }}</span>-->
                    <!--<div class="hr_w" @click="clickInput(0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[0].status"/>-->
                    <span class="tx_nome_w" v-if="editing[0].status">{{ getInterText(inter_ind.nome) }}</span>
                    <input id="nameid" :class="editing[0].status ? 'input_name_w' : 'input_name_w_d input_name_w_user_d'" type="text" v-model="editing[0].texto" tabindex="1" :placeholder="getInterText(inter_ind.nome)" @click="clickInput(0, true)"/>
                    <!--<input id="nameid" class="input_name_m" type="text" v-model="editing[0].texto" v-if="editing[0].status" tabindex="1"/>-->
                    <span v-if="!checkName(editing[0].texto) && editing[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.nome_invalido) }}</span>
                </div>

                <div class="div_nome">
                    <!--<span class="tx_nome_before_w" @click="clickInput(1, true)" v-if="!editing[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>-->
                    <!--<div class="hr_w" @click="clickInput(1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[1].status"/>-->
                    <span class="tx_nome_w" v-if="editing[1].status">E-mail</span>
                    <input id="emailid" :class="editing[1].status ? 'input_name_w' : 'input_name_w_d input_name_w_user_d'" type="email" v-model="editing[1].texto" tabindex="3" placeholder="E-mail" @click="clickInput(1, true)"/>
                    <!--<input id="emailid" class="input_name_m" type="email" v-model="editing[1].texto" v-if="editing[1].status" tabindex="3"/>-->
                    <span v-if="!checkEmail(editing[1].texto) && editing[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome">
                    <!--<span class="tx_nome_before_w" @click="clickInput(2, true)" v-if="!editing[2].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">{{ getInterText(inter_ind.telefone) }}</span>-->
                    <!--<div class="hr_w" @click="clickInput(2, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[2].status"/>-->
                    <span class="tx_nome_w" v-if="editing[2].status">{{ getInterText(inter_ind.telefone) }}</span>
                    <input id="telefoneid" :class="editing[2].status ? 'input_name_w' : 'input_name_w_d input_name_w_user_d'" type="text" v-model="editing[2].texto" tabindex="3" :placeholder="getInterText(inter_ind.telefone)" @click="clickInput(2, true)" v-on:keyup="mphone(editing[2])"/>
                    <!--<input id="telefoneid" class="input_name_m" type="email" v-model="editing[2].texto" v-if="editing[2].status" tabindex="3" v-on:keyup="mphone(editing[2])"/>-->
                    <span v-if="!checkTelefone(editing[2].texto) && editing[2].texto.length>5" class="error_msg">{{ getInterText(inter_ind.telefone_invalido) }}</span>
                </div>
                <span class="warning_msg" style="color: white;">{{ getInterText(inter_ind.telefone_warning) }}</span>

                <div class="div_check" style="margin-top: 1%;">
                    <div class="div_check_in" @click="changeCheckState(0)" onMouseOver="this.style.cursor='pointer'">
                        <span v-if="valid.enterAuto" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check">{{ getInterText(inter_ind.entrar_auto) }}</span>
                </div>

                <div class="div_check" style="margin-top: 1%;">
                    <div class="div_check_in" @click="changeCheckState(1)" onMouseOver="this.style.cursor='pointer'">
                        <span v-if="valid.termos" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check">{{ getInterText(inter_ind.li_concordo_com) }}&nbsp;<a href="/static/pages/politicaprivacidade.html" target="_blank"> {{ getInterText(inter_ind.politica_privacidade) }}.</a></span>
                </div>

                <!--<form action="?" method="POST">-->
                    <!--&lt;!&ndash;  CHAVE DO    SITE: 6LeAhcAUAAAAADMW73ZiaGG6bphq7o9UBIHcQbO-  &ndash;&gt;-->
                    <!--&lt;!&ndash;  CHAVE DO SECRETA: 6LeAhcAUAAAAADLPSOGNeI4uOHqM2C7RQ3LXt9wP  &ndash;&gt;-->
                    <!--<div style="margin-top: 5vh; margin-bottom: 5vh;" class="g-recaptcha" data-sitekey="6LeAhcAUAAAAADMW73ZiaGG6bphq7o9UBIHcQbO-"></div>-->
                <!--</form>-->

                <div class="div_botao_t" @click="goToPasso(1)" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                    <span class="tx_continuar" style="font-size: 2.5vh"> {{ getInterText(inter_ind.continuar) }} </span>
                </div>
            </div>







            <div class="parts" v-if="passoIndex == 1">

                <img id="profileImage" :src="profileSrc" alt="Upload Foto" class="im_profile" @click="$refs.inputImage.click()" style="margin-bottom: -2vh; margin-top: 1vh;">

                <input style="display: none" ref="inputImage" type="file" accept="image/*" @change="onFileSelectedOne"/>
                <!--<input style="display: none" ref="inputImage" type="file" accept=".jpg,.jpeg,.png,.tiff,.gif" @change="onFileSelectedOne"/>-->

                <div class="bt_procurar" @click="$refs.inputImage.click()" onMouseOver="this.style.cursor='pointer'" tabindex="5">
                    <span class="tx_continuar" style="font-size: 2.5vh">{{ getInterText(inter_ind.procurar) }}</span>
                </div>

                <!--<div class="bt_upload" @click="onUploadPhoto()" onMouseOver="this.style.cursor='pointer'" tabindex="6">-->
                    <!--<span class="tx_continuar">Upload</span>-->
                <!--</div>-->

                <img v-if="photos != null && photos.length > 0 && photos[0].loading" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                <div class="div_botao_t" @click="waitUploadProfileFinish()" onMouseOver="this.style.cursor='pointer'" tabindex="7">
                    <span class="tx_continuar" style="font-size: 2.5vh"> {{ getInterText(inter_ind.continuar) }} </span>
                </div>

            </div>

            <div class="parts" v-if="passoIndex == 2" style="width: 100%;">

                <div v-if="!checkPass2(editing[4].texto) || editing[4].texto==''" class="div_aviso">
                    <span class="tx_aviso">{{ getInterText(inter_ind.senha_errada_2) }}</span>
                </div>

                <div class="div_nome">
                    <!--<span class="tx_nome_before_w" @click="clickInput(3, true)" v-if="!editing[3].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>-->
                    <!--<div class="hr_w" @click="clickInput(3, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[3].status"/>-->
                    <span class="tx_nome_w" v-if="editing[3].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <div style="display: flex; flex-direction: row;">
                        <input id="pass1id" :class="editing[3].status ? 'input_name_w' : 'input_name_w_d input_name_w_user_d'" :type='editing[3].show ? "text" : "password"' v-model="editing[3].texto" tabindex="8" :placeholder="getInterText(inter_ind.senha)" @click="clickInput(3, true)"/>
                        <!--<input id="pass1id" class="input_name_m" :type='editing[3].show ? "text" : "password"' v-model="editing[3].texto" tabindex="8"/>-->
                        <img :src='editing[3].show ? "/static/imgs/ic_eye_open.png" : "/static/imgs/ic_eye_close.png"' style="width: 6vw; object-fit: contain;" @click="showPass(3)">
                        <img v-if="checkPass(editing[3].texto) && editing[3].texto!=''" src="/static/imgs/tick1.png" alt="facebook" class="im_tick">
                    </div>
                    <span v-if="!checkPass(editing[3].texto) && editing[3].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada_2) }}</span>
                </div>

                <div class="div_nome" style="margin-bottom: 2vh;">
                    <!--<span class="tx_nome_before_w" @click="clickInput(4, true)" v-if="!editing[4].status" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.senha_confirma) }}</span>-->
                    <!--<div class="hr_w" @click="clickInput(4, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[4].status"/>-->
                    <span class="tx_nome_w" v-if="editing[4].status">{{ getInterText(inter_ind.senha_confirma) }}</span>
                    <div style="display: flex; flex-direction: row;">
                        <input id="pass2id" :class="editing[4].status ? 'input_name_w' : 'input_name_w_d input_name_w_user_d'" :type='editing[4].show ? "text" : "password"' v-model="editing[4].texto" tabindex="9" :placeholder="getInterText(inter_ind.senha_confirma)" @click="clickInput(4, true)"/>
                        <!--<input id="pass2id" class="input_name_m" :type='editing[4].show ? "text" : "password"' v-model="editing[4].texto" tabindex="9"/>-->
                        <img :src='editing[4].show ? "/static/imgs/ic_eye_open.png" : "/static/imgs/ic_eye_close.png"' style="width: 6vw; object-fit: contain;" @click="showPass(4)">
                        <img v-if="checkPass2(editing[4].texto) && editing[4].texto!=''" src="/static/imgs/tick1.png" alt="facebook" class="im_tick">
                    </div>
                    <span v-if="!checkPass2(editing[4].texto) && editing[4].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada_3) }}</span>
                </div>

                <!--<div class="div_check">-->
                    <!--<div class="div_check_in" @click="changeCheckState(1)" onMouseOver="this.style.cursor='pointer'">-->
                        <!--<span v-if="valid.termos" class="tx_checkbox">&#10003;</span>-->
                    <!--</div>-->
                    <!--<span class="tx_check">Li e concordo com a&nbsp;<a href="/static/pages/politicaprivacidade.html" target="_blank"> Política de Privacidade.</a></span>-->
                <!--</div>-->

                <div class="div_botao_t" @click="goToPasso(3)" onMouseOver="this.style.cursor='pointer'" tabindex="10">
                    <span class="tx_continuar" style="font-size: 2.5vh"> {{ getInterText(inter_ind.continuar) }} </span>
                </div>

            </div>




            <div class="parts" v-if="passoIndex == 3">
                <span v-if="loading.form"  class="tx_fim">Aguarde...</span>

                <!--<img  v-if="!loading.form && new_user.firstTime" src="/static/imgs/ic_email.jpg" style="width: 25%; object-fit: contain; margin-bottom: 3vh"/>-->
                <img  v-if="!loading.form && new_user.firstTime" src="/static/imgs/ic_mail2.png" style="width: 25%; object-fit: contain; margin-bottom: 3vh"/>

                <span v-if="!loading.form && new_user.firstTime" class="tx_bemvindo tx_center tx_light" v-html="decodeChars(getInterText(inter_ind.texto_parabens_adv))"/>
                <span v-if="!loading.form && new_user.firstTime" class="tx_bemvindo tx_center tx_light" v-html="getInterText(inter_ind.texto_usuario_cadastrado_p1)"/>
                <span v-if="!loading.form && new_user.firstTime" class="tx_bemvindo tx_center tx_bold">{{ new_user.email }} </span>
                <span v-if="!loading.form && new_user.firstTime" class="tx_bemvindo tx_center tx_light">{{ getInterText(inter_ind.texto_usuario_cadastrado_p2) }} </span>

                <span v-if="!loading.form && !new_user.firstTime" class="tx_bemvindo tx_center tx_light"> {{ getInterText(inter_ind.texto_usuario_existente_p1) }} </span>
                <span v-if="!loading.form && !new_user.firstTime" class="tx_bemvindo tx_center tx_bold"> {{ new_user.email }} </span>
                <span v-if="!loading.form && !new_user.firstTime" class="tx_bemvindo tx_center tx_light"> {{ getInterText(inter_ind.texto_usuario_existente_p2) }} </span>

                <div  v-if="!loading.form" class="div_botao" @click="goToHome(cityIndex)">
                    <span class="tx_continuar">Ok</span>
                </div>

            </div>


        </div>

        <Alert v-if="showAlert || showConfirm" :textProp="textAlert" :confirmProp="showConfirm" @emit-close="closeAlert" @emit-action="actionFunction"/>

    </div>
</template>


<script>
    // import { registerUserMixin } from '../scripts/registerUserMixin'
    import { advMixin } from '../scripts/advMixin'

    export default {
        // mixins: [registerUserMixin],
        mixins: [advMixin],
        mounted() {
            console.log('mounted mobile!!');

            this.valid.captcha = true;

            console.log('Terminei o mounted mobile!!');
        },
    }
</script>


<!--<script src="../scripts/registerUserMixin.js"/>-->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="../assets/css/adv.css" scoped/>
<style src="../assets/css/registerUser.css" scoped/>



// WEBPACK FOOTER //
// src/components/mRegisterUser.vue